<template>
    <md-dialog class="deleteDialog" style="" :md-active.sync="options.showDelete">
        <md-dialog-content style="padding-top: 55px; padding-left: 40px; padding-bottom: 30px;" class="pt-40;">{{
            options.deleteMsg }}</md-dialog-content>
        <md-dialog-actions class="">
            <div class="pr-30 pb-40">
                <md-button tabindex="8" class="md-raised secondary"
                    @click="options.showDelete = false"><strong>{{ options.Lang.zurück }}</strong></md-button>
                <md-button class="md-raised md-primary" @click="deleteImage(img)"><strong>{{ options.Lang.löschen }}</strong></md-button>
            </div>
        </md-dialog-actions>
    </md-dialog>
</template>
  
<script>
export default {
    name: 'deleteDialog',
    props: {
        img: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
    },
    data: () => ({
    }),
    methods: {
        deleteImage(img) {
            this.options.showDelete = false
        }
    }
}
</script>
  
<style lang="scss" scoped>
.deleteDialog {
    max-width: 600px !important;
    width: 600px !important;
    margin: 0 auto;
    font-size: 16px;
    padding-bottom: 100px;
}
</style>